import React, { useState } from 'react';
import { LanguageSelector, Button, Card, Switch, Accordion } from '@components/common';
import { useLanguage } from '@contexts/LanguageContext';
import { useNotification } from '@hooks/useNotification';
import './UserSettings.scss';

const UserSettings = () => {
    const { t } = useLanguage();
    const notify = useNotification();
    const { currentLanguage } = useLanguage();

    const [settings, setSettings] = useState({
        notifications: true,
        emailNotifications: true,
        inAppNotifications: true,
        lateReturnAlerts: true,
    });

    const handleSettingChange = (key, value) => {
        setSettings(prev => ({
            ...prev,
            [key]: value
        }));
    };

    // Render functions for different settings sections
    const renderNotificationSettings = () => {
        // TODO: To be implemented - notification settings functionality
        // This section will need backend integration for user preferences
        return (
            <Card title={t('settings.notifications.title')}>
                <div className="setting-resource">
                    <Switch
                        label={t('settings.notifications.enable')}
                        checked={settings.notifications}
                        onChange={(checked) => handleSettingChange('notifications', checked)}
                    />

                    {settings.notifications && (
                        <Accordion
                            title={t('settings.notifications.options')}
                            defaultExpanded={true}
                            className="notification-options-accordion"
                        >
                            <div className="notification-options-group">
                                <div className="setting-resource">
                                    <Switch
                                        label={t('settings.notifications.email')}
                                        description={t('settings.notifications.emailDesc')}
                                        checked={settings.emailNotifications}
                                        onChange={(checked) => handleSettingChange('emailNotifications', checked)}
                                    />
                                </div>

                                <div className="setting-resource">
                                    <Switch
                                        label={t('settings.notifications.inApp')}
                                        description={t('settings.notifications.inAppDesc')}
                                        checked={settings.inAppNotifications}
                                        onChange={(checked) => handleSettingChange('inAppNotifications', checked)}
                                    />
                                </div>

                                <div className="setting-resource">
                                    <Switch
                                        label={t('settings.notifications.lateReturn')}
                                        description={t('settings.notifications.lateReturnDesc')}
                                        checked={settings.lateReturnAlerts}
                                        onChange={(checked) => handleSettingChange('lateReturnAlerts', checked)}
                                    />
                                </div>
                            </div>
                        </Accordion>
                    )}
                </div>
            </Card>
        );
    };

    const renderLanguageSettings = () => {
        return (
            <Card title={t('settings.language.title')}>
                <div className="setting-resource">
                    <div className="language-setting">
                        <LanguageSelector
                            variant="dropdown"
                            showLabel={true}
                        />
                        <p className="language-setting__description">
                            {t('settings.language.currentLanguage')}: <strong>{t('settings.language.' + (currentLanguage === 'en' ? 'english' : 'french'))}</strong>
                        </p>
                    </div>
                </div>
            </Card>
        );
    };

    return (
        <div className="user-settings">
            <div className="settings-grid">
                {/*renderNotificationSettings()*/}
                {renderLanguageSettings()}
            </div>
        </div>
    );
};

export default UserSettings;
